// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".goods_drawer_basic_config .sort .radio[data-v-f927f9de] {\n  margin-top: 0.625rem;\n}\n.goods_drawer_basic_config .sort .radio[data-v-f927f9de]:first-child {\n  margin-top: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
